import { AdminConsoleAccessGuard, AdminPageContainer, AdminSectionCard } from "../../components/admin-console/admin-console-shell";
import { PageStoreProvider } from "./reference-document-types-page.lib";
import { DocumentTypeModal } from "./local-components/document-type-modal";
import { DocumentTypesTabs } from "./local-components/document-types-tabs";
import { ReferenceContent } from "./local-components/reference-content";
import { WorkTypeModal } from "./local-components/work-type-modal";

/** ЛК администратора услуг — «Справочники — Типы документов». */
const ReferenceDocumentTypesPage = () => (
  <AdminConsoleAccessGuard>
    <PageStoreProvider>
      <DocumentTypeModal />
      <WorkTypeModal />
      <AdminPageContainer>
        <AdminSectionCard title="Справочники" subtitle="Нормативно-справочная информация, общая для всего портала">
          <DocumentTypesTabs />
          <ReferenceContent />
        </AdminSectionCard>
      </AdminPageContainer>
    </PageStoreProvider>
  </AdminConsoleAccessGuard>
);

export default ReferenceDocumentTypesPage;
